import axios from 'axios'
import { motion } from 'framer-motion'
import { useCallback, useEffect, useState } from 'react'
import { FaArrowLeft } from 'react-icons/fa'
import { FiAlertTriangle } from 'react-icons/fi'
import { useDispatch, useSelector } from 'react-redux'
import {
  ColumnsTable,
  IExistence,
  // IItem,
  InventorySearch,
  IWarehouse,
} from 'safe'
import Empty from '../../components/Display/Empty'
// import FloatingMenu from '../../components/Display/FloatingMenu'
import Modal from '../../components/Display/Modal'
import Table from '../../components/Display/Table'
import Button from '../../components/General/Button'
import { ColumnItemWrapper } from '../../components/General/ColumnItemWrapper'
import { useLocalStorageState } from '../../hooks/useLocalStorageState'
import { fetchExistences, cleanItems } from '../../redux/actions/existence'
// import { fetchItems } from '../../redux/actions/items'
import { RootState } from '../../redux/store'
import LocationCard from '../Location/LocationCard'
import LoadForm from './LoadForm'
import UnloadForm from './UnloadForm'
import EmptyBox from '../../assets/animations/empty_box.json'
import { formatAmount, formatPipe, formatter, getDenomination, transformDate } from '../../utils/utils'
import useSnackBars from '../../hooks/SnackbarConsumerHook'
import { DataTabView } from '../../components/Display/ViewWithTabs'
import { tax } from '../../userConfig'
import AdjustExistence from './AdjustExistence'
import ModalViewWithTabs from '../../components/Display/ModalViewWithTabs'
import PdfView from '../../components/Display/PdfView'
import LocationForm from '../Location/LocationForm'
import {
  createWarehouse,
  fetchWarehouses,
  removeWarehouse,
  updateWarehouse,
} from '../../redux/actions/warehouses'
import FloatingForm from '../../components/Display/FloatingForm'
import InventorySearchFormFloating from '../Inventory/InventorySearchFormFloating'
import AdvancedInventoryForm from '../../components/Display/AdvancedInventoryForm'

const server = process.env.REACT_APP_SERVER_URL

const Existence = ({ setHeaderActions }) => {
  const { addAlert } = useSnackBars()

  const userRole = useSelector(
    (state: RootState) => state.auth.user['custom:user_role']
  )

  const warehouses = useSelector((state: RootState) => state.warh.warehouses)

  const existences = useSelector((state: RootState) => state.exst1.existences)

  const numberOfPages = useSelector(
    (state: RootState) => state.exst1.numberOfPages
  )

  const dispatch = useDispatch()

  const [existencesToAdjust, setExistencesToAdjust] = useState<IExistence[]>([])

  const [adjustExistenceModal, setAdjustExistenceModal] = useState<boolean>(
    false
  )

  const [adjustModal, setAdjustModal] = useState<boolean>(false)

  const [pdfModalAndData, setPdfModalAndData] = useState<{
    data: string[][]
    modal: boolean
  }>({
    data: [],
    modal: false,
  })

  const [, setModal] = useState<boolean>(false)

  const [editingLocation, setEditingLocation] = useState<any>(null)

  const [showLoad, setShowLoad] = useState<boolean>(false)

  const [showUnload, setShowUnload] = useState<boolean>(false)

  const [selectedLocation, setSelectedLocation] = useState<IWarehouse | null>(
    null
  )

  const [userConfig] = useLocalStorageState('user-config')

  const [showModalSearch, setShowModalSearch] = useState<boolean>(false)

  const [currentPage, setCurrentPage] = useState<number>(0)

  const [currentEvaluate, setCurrentEvaluate] = useState<string>('none')

  const [searchParams, setSearchParams] = useState<string[]>([])

  const [fastSearch, setFastSearch] = useState<string>('')

  const [loading, setLoading] = useState<boolean>(false)

  const [modalFromRow, setModalFromRow] = useState<boolean>(false)

  const [dataWithTabs, setDataWithTabs] = useState<DataTabView[]>([])

  const [showAddModal, setShowAddModal] = useState<boolean>(false)

  // const [, setLocationOpen] = useState<boolean[]>([]) // fix this

  const columns: ColumnsTable[] = [
    {
      title: 'Nombre',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: 'Categoría',
      dataIndex: 'category.name',
      key: 'category.name',
    },
    // {
    //   title: 'Categoría',
    //   dataIndex: 'category',
    //   key: 'category',
    // },
    {
      title: 'Marca',
      dataIndex: 'brand',
      key: 'brand',
    },
    {
      title: 'SKU',
      dataIndex: 'item.sku',
      key: 'sku',
      render: (id: number, record: any) => (
        <ColumnItemWrapper
        subElement="paragraph"
        subElementStyle={`${record?.sku ? '' : 'text-gray-600'}`}
        >
          {record?.sku ? record?.sku : 'N/A'}
        </ColumnItemWrapper>
      ),
    },
    {
      title: 'Código de barras',
      dataIndex: 'barcode',
      key: 'barcode',
      render: (id: number, record: any) => (
        <ColumnItemWrapper
        subElement="paragraph"
        subElementStyle={`${record?.barcode ? '' : 'text-gray-600'}`}
        >
          {record?.barcode ? record?.barcode : 'N/A'}
        </ColumnItemWrapper>
      ),
    },
    {
      title: 'Precio',
      align: 'center',
      dataIndex: 'price',
      key: 'price',
      render: (id: number, record: any) => (
        <ColumnItemWrapper>
          { `${getDenomination(record?.currency?.id)} ${formatPipe(record?.price)}` }
        </ColumnItemWrapper>
      ),
      width: 70
    },
    {
      title: 'Cantidad',
      align: 'center',
      dataIndex: 'quantity',
      key: 'quantity',
      width: 50,
      render: (id: number, record: any) => (
        <ColumnItemWrapper>
          {record.quantity}
          {/* {formatAmount(record.quantity, record.item.unit)} */}
        </ColumnItemWrapper>
      ),
    },
    // {
    //   title: 'Exento',
    //   dataIndex: 'item.exempt',
    //   align: 'center',
    //   key: 'exempt',
    //   render: (id: number, record: any) => (
    //     <ColumnItemWrapper>
    //       <p>{record?.item?.exempt ? 'Sí' : 'No'}</p>
    //     </ColumnItemWrapper>
    //   ),
    // },
    // {
    //   title: 'Precio',
    //   dataIndex: 'item.price',
    //   key: 'price',
    //   render: (id: number, record: any) => (
    //     <ColumnItemWrapper>
    //       <p
    //         className={`${
    //           !(record?.item?.price?.length > 0)
    //             ? 'text-warning'
    //             : 'text-success'
    //         }`}
    //       >
    //         {record.item?.price.length > 0 ? (
    //           'Bs ' + record.item?.price[0]?.amount
    //         ) : (
    //           <span>
    //             Sin Precio <FiAlertTriangle className="text-warning inline" />
    //           </span>
    //         )}
    //       </p>
    //     </ColumnItemWrapper>
    //   ),
    // },
    // {
    //   title: 'Modificado',
    //   dataIndex: 'date',
    //   key: 'date',
    //   render: (id: number, record: any) => (
    //     <ColumnItemWrapper>
    //       <p>{formatter(record?.date)}</p>
    //     </ColumnItemWrapper>
    //   ),
    // },
  ]

  const getOrderKeys = (key: string, record?) => {
    if (key === 'name') return ['item', 'name']
    if (key === 'sku') return ['item', 'sku']
    if (key === 'price') return ['item', 'price']
    if (key === 'barcode') return ['item', 'barcode']
    if (key === 'exempt') return ['item', 'exempt']
    return [key]
  }

  const onFilterActions = (values) => {
    if (selectedLocation) {
      const {addAction, ...rest} = values
      return rest
    } else {
      const { advancedSearch, onAdjust, onPrint, ...rest } = values
      return rest
    }
  }

  const fetchExistencesOfPdf = async () => {
    if (selectedLocation) {
      try {
        addAlert({
          message: 'Cargando existencias',
          status: 'loading',
        })
        interface ServerResponse {
          status: number
          existencesOfWarehouse: IExistence[]
        }
        const {
          data: { existencesOfWarehouse },
        } = await axios.get<ServerResponse>(
          `${server}/inventory/existence?evaluate=all&idWarehouse=${selectedLocation.id}`
        )
        const pdfData: string[][] = []
        for (const existence of existencesOfWarehouse) {
          const row: string[] = []
          row.push(existence.item.barcode || existence.item.sku || 'Sin código')
          row.push(existence.item.name || 'Sin nombre')
          row.push(formatAmount(existence.quantity, existence.item.unit))
          pdfData.push(row)
        }
        setPdfModalAndData({
          data: pdfData,
          modal: true,
        })
        addAlert({
          message: 'Pdf Generado con éxito',
          status: 'success',
        })
      } catch (error) {
        addAlert({
          message: 'Error al generar pdf de existencias',
          status: 'error',
        })
      }
      return
    }
    addAlert({
      message: 'Debe seleccionar un almacén primero',
      status: 'error',
    })
  }

  useEffect(() => {
    if (userRole === 'seniat') { 
      setHeaderActions(
        onFilterActions({
          // searchAction: () => {
          //   setShowModalSearch(true)
          // },
          cleanFilters: {
            sort: () => {},
            search: async () => {
              getItemsByWarehouse([], 0)
              // setSearchParams([])
              // setCurrentEvaluate('none')
              // if (currentPage === 0) {
              //   setLoading(true)
              //   await dispatch(
              //     fetchExistences(
              //       selectedLocation?.id,
              //       [],
              //       [`pageNumber=${1}`, `pageSize=${userConfig.rowsPerPage}`]
              //     )
              //   )
              //   setLoading(false)
              // }
              // setCurrentPage(0)
            },
            isSearch: Boolean(searchParams.length > 0),
          },
          advancedSearch: async (value) => {
            if (typeof value === 'boolean') {
              setShowModalSearch(value)
              return
            }
            // setSearchParams([`fastSearch=${value}`])
            // setFastSearch(value)
            getItemsByWarehouse(searchParams, currentPage, value)
  
            // if (currentPage === 0) {
            //   await dispatch(
            //     fetchExistences(
            //       selectedLocation?.id,
            //       [`fastSearch=${value}`],
            //       [`pageNumber=${currentPage + 1}`, `pageSize=${userConfig.rowsPerPage}`],
            //       currentEvaluate
            //     )
            //   )
            // } else {
            //   setCurrentPage(0)
            // }
          },
          // onAdjust: () => {
          //   setAdjustModal(true)
          // },
          // onPrint: existences.length
          //   ? () => {
          //       fetchExistencesOfPdf()
          //     }
          //   : undefined,
        })
      )
    } else {
      setHeaderActions(
        onFilterActions({
          addAction: () => setShowAddModal(true),
          // searchAction: () => {
          //   setShowModalSearch(true)
          // },
          cleanFilters: {
            sort: () => {},
            search: async () => {
              getItemsByWarehouse([], 0)
              // setSearchParams([])
              // setCurrentEvaluate('none')
              // if (currentPage === 0) {
              //   setLoading(true)
              //   await dispatch(
              //     fetchExistences(
              //       selectedLocation?.id,
              //       [],
              //       [`pageNumber=${1}`, `pageSize=${userConfig.rowsPerPage}`]
              //     )
              //   )
              //   setLoading(false)
              // }
              // setCurrentPage(0)
            },
            isSearch: Boolean(searchParams.length > 0),
          },
          advancedSearch: async (value) => {
            if (typeof value === 'boolean') {
              setShowModalSearch(value)
              return
            }
            // setSearchParams([`fastSearch=${value}`])
            // setFastSearch(value)
            getItemsByWarehouse(searchParams, currentPage, value)
  
            // if (currentPage === 0) {
            //   await dispatch(
            //     fetchExistences(
            //       selectedLocation?.id,
            //       [`fastSearch=${value}`],
            //       [`pageNumber=${currentPage + 1}`, `pageSize=${userConfig.rowsPerPage}`],
            //       currentEvaluate
            //     )
            //   )
            // } else {
            //   setCurrentPage(0)
            // }
          },
          // onAdjust: () => {
          //   setAdjustModal(true)
          // },
          // onPrint: existences.length
          //   ? () => {
          //       fetchExistencesOfPdf()
          //     }
          //   : undefined,
        })
      )
    }
  
    return () => setHeaderActions(null)
  }, [
    setHeaderActions,
    selectedLocation,
    searchParams,
    currentPage,
    existences,
  ])

  // useEffect(() => {
  //     console.log("existences", existences)
  // }, [existences])

  // const onDelete = (values): void => {
  //   console.log('values', values)
  // }

  const onGetItemsByWarehouses = async (
    location: IWarehouse
  ): Promise<void> => {
    /*Al terminar la peticion, muestra la tabla */
    // dispatch(fetchExistences(location.id))
    try {
      await dispatch(
        fetchExistences(
          location.id,
          searchParams,
          [`pageNumber=${1}`, `pageSize=${userConfig.rowsPerPage}`],
          currentEvaluate
        )
      )
      setSelectedLocation(location)
    } catch (err) {
      addAlert({
        message: `Error al obtener existencias`,
        status: 'error',
      })
    }
  }

  const onCleanItems = async (): Promise<void> => {
    console.log("llega...")
    await dispatch(fetchWarehouses())
    dispatch(cleanItems())
    console.log("llegandoo...")
    setCurrentPage(0)
    setSearchParams([])
    setSelectedLocation(null)
    // setSearchParams([])
    // setCurrentEvaluate('none')
    // setCurrentPage(0)
  }

  const onLoadSubmit = async (items: any[], accounting: boolean) => {
    // console.log('itemssss', items)
    let bodyLoad = {
      destination: {
        id: selectedLocation?.id,
        locationType: 'WAREHOUSE',
      },
      items: items.reduce((a, b) => {
        if (b?.type !== 'FINISHED_PRODUCT') {
          return [...a, {amount: b.amount, idItem: b.idItem}]
        }
        return a
      }, []),
      accounting
    }

    let bodyLoadFinished = {
      destination: {
        id: selectedLocation?.id,
        locationType: 'WAREHOUSE',
      },
      items: items.reduce((a, b) => {
        if (b?.type === 'FINISHED_PRODUCT') {
          return [...a, {amount: b.amount, idItem: b.idItem}]
        }
        return a
      }, [])}

    try {
      let checkForFinished = bodyLoadFinished?.items.length > 0
      let checkForNormal = bodyLoad.items.length > 0
      console.log("VER...", bodyLoad)
      console.log("ver 2...", bodyLoadFinished)

      if (checkForFinished && checkForNormal) {
        try {
          await axios.post(`${server}/inventory/load`, bodyLoad)
          await axios.post(`${server}/inventory/load/finished-product`, bodyLoadFinished)
          // await dispatch(
          //   fetchExistences(
          //     selectedLocation?.id,
          //     [],
          //     [`pageNumber=${1}`, `pageSize=${userConfig.rowsPerPage}`]
          //   )
          // )
          getItemsByWarehouse([], 0)
          // setShowLoad(true)
          setShowLoad(false)
          addAlert({
            message: 'Carga de inventario realizada con éxito',
            status: 'success',
          })
        } catch (err) {
          addAlert({
            message: `Error al realizar la carga`,
            status: 'error',
          })
        }
        // console.log("responsee...", response)
      } else if (checkForFinished) {
        try {
          await axios.post(`${server}/inventory/load/finished-product`, bodyLoadFinished)
          // await dispatch(
          //   fetchExistences(
          //     selectedLocation?.id,
          //     [],
          //     [`pageNumber=${1}`, `pageSize=${userConfig.rowsPerPage}`]
          //   )
          // )
          getItemsByWarehouse([], 0)

          setShowLoad(false)
          addAlert({
            message: 'Carga de inventario realizada con éxito',
            status: 'success',
          })
        } catch (err) {
          addAlert({
            message: `Error al realizar la carga`,
            status: 'error',
          })
        }
      } else if (checkForNormal) {
        try {
          await axios.post(`${server}/inventory/load`, bodyLoad)
          // await dispatch(
          //   fetchExistences(
          //     selectedLocation?.id,
          //     [],
          //     [`pageNumber=${1}`, `pageSize=${userConfig.rowsPerPage}`]
          //   )
          // )
          getItemsByWarehouse([], 0)

          setShowLoad(false)
          addAlert({
            message: 'Carga de inventario realizada con éxito',
            status: 'success',
          })
        } catch (err) {
          addAlert({
            message: `Error al realizar la carga`,
            status: 'error',
          })
        }
      }

     
    } catch (error) {
      addAlert({
        message: `Error al realizar la carga`,
        status: 'error',
      })
    }
  }

  const onUnloadSubmit = async (items: any[], accounting: boolean) => {
    // console.log("items unload", items)
    let bodyUnload = {
      accounting,
      destination: {
        id: selectedLocation?.id,
        locationType: 'WAREHOUSE',
      },
      items: items.map((v) => ({ idItem: v.idItem, amount: v.amount })),
    }

    try {
      await axios.post(`${server}/inventory/unload`, bodyUnload)
      setShowUnload(false)
      // await dispatch(
      //   fetchExistences(
      //     selectedLocation?.id,
      //     [],
      //     [`pageNumber=${1}`, `pageSize=${userConfig.rowsPerPage}`]
      //   )
      // )
      getItemsByWarehouse([], 0)
      addAlert({
        message: 'Descarga de inventario realizada con éxito',
        status: 'success',
      })
    } catch (error) {
      addAlert({
        message: `Error al realizar descarga`,
        status: 'error',
      })
    }
  }

  const getItemsByWarehouse = async (
    params: string[] = searchParams,
    pageNumber: number = 0,
    fastParam = fastSearch
    ) => {
    setLoading(true)
    // setShowModalSearch(false)

    const paginationParams = [
      `pageNumber=${pageNumber + 1}`,
      `pageSize=${userConfig.rowsPerPage}`,
    ]

    setFastSearch(fastParam)

    setSearchParams(params)

    // setCurrentPage(pageNumber + 1)

    let newParams = [...params]

    if (fastParam) {
      newParams.push(`fastSearch=${fastParam}`)
    }

    await dispatch(
      fetchExistences(
        selectedLocation?.id,
        newParams,
        paginationParams,
        ''
      )
    )

    setLoading(false)
  }

  useEffect(() => {
    console.log('current Page', currentPage)
    if (selectedLocation) {
      getItemsByWarehouse()
    }
  }, [])

  useEffect(() => {
    return () => {
      dispatch(cleanItems())
    }
  }, [])

  useEffect(() => {
    dispatch(fetchWarehouses())
  }, [])
  

  const onSubmitFilter = async (values: InventorySearch): Promise<void> => {
    if (values.typeSelected === 'code') {
      setCurrentEvaluate('code')
      setSearchParams([`code=${values.code}`])
      if (currentPage === 0) {
        setLoading(true)
        await dispatch(
          fetchExistences(
            selectedLocation?.id,
            [`code=${values.code}`],
            [
              `pageNumber=${currentPage + 1}`,
              `pageSize=${userConfig.rowsPerPage}`,
            ],
            'code'
          )
        )
        setLoading(false)
      } else {
        setCurrentPage(0)
      }
    }

    if (values.typeSelected === 'keywords') {
      setCurrentEvaluate('name')
      setSearchParams([`name=${values.name}`])
      if (currentPage === 0) {
        setLoading(true)
        await dispatch(
          fetchExistences(
            selectedLocation?.id,
            [`name=${values.name}`],
            [
              `pageNumber=${currentPage + 1}`,
              `pageSize=${userConfig.rowsPerPage}`,
            ],
            'name'
          )
        )
        setLoading(false)
      } else {
        setCurrentPage(0)
      }
    }

    if (values.typeSelected === 'category') {
      if (currentPage === 0) {
        if (values.subCategory !== '0') {
          setCurrentEvaluate('subcategory')
          setLoading(true)
          await dispatch(
            fetchExistences(
              selectedLocation?.id,
              [`idSubCategory=${values.subCategory}`],
              [
                `pageNumber=${currentPage + 1}`,
                `pageSize=${userConfig.rowsPerPage}`,
              ],
              'subcategory'
            )
          )
          setLoading(false)
          setSearchParams([`idSubCategory=${values.subCategory}`])
        } else {
          setCurrentEvaluate('category')
          setLoading(true)
          await dispatch(
            fetchExistences(
              selectedLocation?.id,
              [`idCategory=${values.category}`],
              [
                `pageNumber=${currentPage + 1}`,
                `pageSize=${userConfig.rowsPerPage}`,
              ],
              'category'
            )
          )
          setLoading(false)
          setSearchParams([`idCategory=${values.category}`])
        }
      } else {
        if (values.subCategory !== '0') {
          setCurrentEvaluate('subcategory')
          setSearchParams([`idSubCategory=${values.subCategory}`])
          setCurrentPage(0)
        } else {
          setCurrentEvaluate('category')
          setSearchParams([`idCategory=${values.category}`])
          setCurrentPage(0)
        }
      }
    }
    setShowModalSearch(false)
  }

  const fetchExistencesToAdjust = async (
    values: InventorySearch
  ): Promise<void> => {
    try {
      addAlert({
        message: 'Buscando existencias...',
        status: 'loading',
      })
      if (selectedLocation) {
        let response
        if (values.typeSelected === 'code') {
          response = await axios.get(
            `${server}/inventory/existence?evaluate=code&idWarehouse=${selectedLocation.id}&code=${values.code}`
          )
        }

        if (values.typeSelected === 'keywords') {
          response = await axios.get(
            `${server}/inventory/existence?evaluate=name&idWarehouse=${selectedLocation.id}&name=${values.name}`
          )
        }

        if (values.typeSelected === 'category') {
          const evaluate =
            values.subCategory === '0' ? 'category' : 'subcategory'
          response = await axios.get(
            `${server}/inventory/existence?evaluate=${evaluate}&idWarehouse=${
              selectedLocation.id
            }&idCategory=${values.category}${
              values.subCategory !== '0'
                ? '&idSubCategory=' + values.subCategory
                : ''
            }&pageSize=9999&pageNumber=1`
          )
        }
        if (response.data.existencesOfWarehouse.length) {
          setExistencesToAdjust(response.data.existencesOfWarehouse)
          setAdjustExistenceModal(true)
          setAdjustModal(false)
          addAlert({
            message: 'Existencias cargadas...',
            status: 'success',
          })
          return
        }
        addAlert({
          message:
            'No se encontraron existencias con los parámetros especificados',
          status: 'warning',
        })
      } else {
        addAlert({
          message: 'Debe haber un almacén seleccionado',
          status: 'error',
        })
      }
    } catch (error: any) {
      addAlert({
        message: error.response.data.message || 'Error del servidor',
        status: 'error',
      })
    }
  }

  const pressRow = (existence: IExistence) => {
    const itemDetails = { title: '', data: '' }
    const priceDetails = { title: '', data: '' }
    const batchDetails = { title: '', data: '' }
    const codeDetails = { title: '', data: '' }

    itemDetails.title = 'Artículo'
    itemDetails.data += `Nombre: ${existence.item.name}\n`
    itemDetails.data += `Descripción: ${existence.item.description}\n`
    itemDetails.data += `Marca: ${existence.item.brand}\n`
    existence.item.barcode &&
      (itemDetails.data += `Código de barras: ${existence.item.barcode}\n`)
    existence.item.sku && (itemDetails.data += `SKU: ${existence.item.sku}\n`)
    itemDetails.data += `Exento: ${existence.item.exempt ? 'Sí' : 'No'}\n`
    itemDetails.data += `Categoría: ${existence.item.category.name}\n`
    itemDetails.data += `Subcategoría: ${existence.item.subcategory.name}\n`
    itemDetails.data += `Unidad de Medida: ${existence.item.unit.name}\n`
    itemDetails.data += `Abreviatura de Unidad: ${existence.item.unit.abbreviatedName}\n`

    const dataToShow = [itemDetails]

    if (existence.item.cost.length > 0 && existence.item.price.length > 0) {
      priceDetails.title = 'Costos y Precios'
      existence.item.price.length > 0 &&
        // (priceDetails.data += `Precio:\t Bs ${existence.item.price[0].amount}\n`)
      existence.item.cost.length > 0 &&
        (priceDetails.data += `Costo:\t Bs ${existence?.item?.cost[0]?.amount}\n`)
      // priceDetails.data += `Ganancia:\t   ${Math.round(
      //   (Number(existence.item.price[0].amount) /
      //     Number(existence?.item?.cost[0]?.amount) -
      //     1) *
      //     100
      // )}%\n`
      priceDetails.data += `Impuesto:\t   ${
        existence.item.exempt ? 'exento' : tax + '%'
      }\n`
      // !existence.item.exempt &&
      //   (priceDetails.data += `Precio antes de Impuesto:\t Bs ${Number(
      //     (
      //       Number(existence.item.price[0].amount) /
      //       (1 + Number(tax) / 100)
      //     ).toFixed(2)
      //   )}`)
      dataToShow.push(priceDetails)
    }

    if (existence.item.batch.length > 0) {
      batchDetails.title = 'Rotación'
      existence.item.batch.length > 0 &&
        (batchDetails.data += `Fecha de creación: ${transformDate(
          existence.item.batch[0].creation_date
        )}\n`)
      existence.item.batch.length > 0 &&
        (batchDetails.data += `Fecha de expiración: ${transformDate(
          existence.item.batch[0].expiration_date
        )}\n`)
      existence.item.batch.length > 0 &&
        (batchDetails.data += `Lote: ${existence.item.batch[0].batch}\n`)
      existence.item.batch.length > 0 &&
        (batchDetails.data += `Fecha de rotación: ${transformDate(
          existence.item.batch[0].rotation_date
        )}\n`)
      dataToShow.push(batchDetails)
    }

    if (existence.item.associatedCode.length > 0) {
      codeDetails.title = 'Códigos'
      existence.item.barcode &&
        (codeDetails.data += `Código de barras: ${existence.item.barcode}\n`)
      existence.item.sku && (codeDetails.data += `SKU: ${existence.item.sku}\n`)
      codeDetails.data += `Códigos asociados:\n`
      for (const code of existence.item.associatedCode) {
        codeDetails.data += `  - ${code.code}\n`
      }
      dataToShow.push(codeDetails)
    }

    existence.item.cost.length > 0 &&
      existence.item.price.length > 0 &&
      dataToShow.push(priceDetails)
    existence.item.batch.length > 0 && dataToShow.push(batchDetails)
    existence.item.associatedCode.length > 0 && dataToShow.push(codeDetails)
    setDataWithTabs(dataToShow)
    setModalFromRow(true)
  }

  const onSubmit = async (values) => {
    if (editingLocation) {
      setLoading(true)
      try {
        addAlert({ message: 'Actualizando almacén...', status: 'loading' })
        
        const body = {
          name: values.name,
          description: values.description,
          id: values?.id
        }

        await axios.patch(`${server}/inventory/warehouse`, body)

        await dispatch(fetchWarehouses())

        addAlert({
          message: 'Almacén actualizado con éxito',
          status: 'success',
        })
      } catch (e) {
        addAlert({
          message: 'Error al crear o actualizar almacén',
          status: 'error',
        })
      } finally {
        setLoading(false)
        setShowAddModal(false)
      }
    } else {
      setLoading(true)
      try {
        console.log('values', values)
        addAlert({ message: 'Creando almacén...', status: 'loading' })
        const _values: Omit<IWarehouse, 'id'> = {
          ...values,
        }
        await dispatch(createWarehouse(_values))
        addAlert({ message: 'Almacén creado con éxito', status: 'success' })
      } catch (e) {
        addAlert({ message: 'Error al crear almacén', status: 'error' })
      } finally {
        setLoading(false)
        setShowAddModal(false)
      }
    }
  }

  const onDelete = async (values) => {
    setLoading(true)
    const _values: IWarehouse = {
      ...values,
    }
    addAlert({ message: 'Eliminando almacén...', status: 'loading' })
    try {
      await dispatch(removeWarehouse(_values))
      // setLocationOpen((prev) => prev.map((b) => false))
      addAlert({ message: 'Almacén eliminado con éxito', status: 'success' })
      setModal(false)
    } catch (e) {
      addAlert({ message: 'Error al eliminar almacén', status: 'error' })
    } finally {
      setLoading(false)
    }
  }

  return (
    <div>
      {selectedLocation && (
        <div className="flex-row flex justify-between mb-8">
          <div className="flex space-x-2 mt-3 px-1 block">
            <Button
              classes="border-none"
              onClick={() => onCleanItems()}
              type="arrow"
              warehouseType={selectedLocation.warehouseType}
            >
              <FaArrowLeft size={30} />
            </Button>

            <h1
              className={`text-lg ${
                selectedLocation.warehouseType === 'PRODUCTION' &&
                'text-primaryOrange-dark dark:text-primaryOrange'
              } ${
                selectedLocation.warehouseType === 'SALE FLOOR' &&
                'dark:text-primaryGreen-300 text-primaryGreen-500'
              } ${
                selectedLocation.warehouseType === 'WAREHOUSE' &&
                'text-primary-600'
              }`}
            >
              {selectedLocation.name}
            </h1>
          </div>

          {/* Aqui van los botones de carga y descarga */}
          <div className="flex space-x-2 mt-3 px-1 block">
            <Button
              type="outline"
              classes="w-1/2 mr-4"
              onClick={() => setShowLoad(true)}
              htmlType="button"
            >
              Cargar
            </Button>

            <Button
              type="outline"
              classes={`w-1/2 mr-4 ${
                existences.length === 0 && 'opacity-20 cursor-default'
              }`}
              onClick={() => {
                existences.length > 0 && setShowUnload(true)
              }}
              htmlType="button"
            >
              Descargar
            </Button>
          </div>
        </div>
      )}

      {warehouses &&
        existences.length === 0 &&
        warehouses?.length > 0 &&
        selectedLocation == null && (
          <>
            <h2 className="font-semibold text-lg text-primary-900 dark:text-white mb-6">
              Almacenes
            </h2>
            <div className="grid md:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4 gap-6 px-1">
              {warehouses.map((location, k) => (
                <LocationCard
                  key={location.id}
                  location={location}
                  setModal={setShowAddModal}
                  onClickCard={userRole !== 'seniat' ? onGetItemsByWarehouses : undefined}
                  setEditingLocation={setEditingLocation}
                  onDelete={onDelete}
                  enableFloating={false}
                />
              ))}
            </div>
          </>
        )}

      {existences.length === 0 && selectedLocation && (
        <Empty
          animationProps={{
            height: 200,
            width: 200,
            animation: EmptyBox,
          }}
          lottieProps={{ style: { position: 'relative', zIndex: 1 } }}
        >
          <p className="font-semibold max-w-xs text-center relative-top-5 z-10 text-sm text-coolGray-500">
            Agrega artículos para cargarlos a su existencia
          </p>
        </Empty>
      )}

      {existences.length > 0 && (
        // <AnimatePresence>
        <motion.div
          animate={{ x: [100, 0] }}
          transition={{ duration: 0.3, ease: 'easeOut' }}
        >
          <Table
            evaluateNegativeRow={true}
            data={existences}
            columns={columns}
            pages={numberOfPages}
            pageSelected={currentPage}
            loading={loading}
            setPageSelected={(page) => {
              console.log("page...", page)
              getItemsByWarehouse(searchParams, page)
            }}
            setLoading={setLoading}
            // onPressButton={pressRow}
            getOrderKeys={getOrderKeys}
          />
        </motion.div>
        // </AnimatePresence>
      )}
      <Modal
        display={showLoad}
        onClose={() => {
          setShowLoad(false)
        }}
        // modalClasses="w-5/12 py-4 px-12"
      >
        <LoadForm
          onLoad={onLoadSubmit}
          selectedLocation={selectedLocation}
          onClose={() => setShowLoad(false)}
        ></LoadForm>
      </Modal>

      <Modal
        display={showUnload}
        onClose={() => {
          setShowUnload(false)
        }}
        // modalClasses="w-5/12 py-4 px-12"
      >
        <UnloadForm
          warehouseId={selectedLocation?.id}
          onUnload={onUnloadSubmit}
          onClose={() => setShowUnload(false)}
        ></UnloadForm>
      </Modal>

      {/* <ModalInventorySearch
        onSubmitInventory={onSubmitFilter}
        modalSearch={showModalSearch}
        onCloseModalSearch={() => setShowModalSearch(false)}
      /> */}

      {/* <FloatingForm
        visible={showModalSearch}
        onClose={() => setShowModalSearch(false)}
        topClass="top-16"
        rightClass="right-10"
        containerClass="w-2/6"
      > */}
        {/* <InventorySearchFormFloating onCloseModalSearch={() => setShowModalSearch(false)}
        onSubmitInventory={onSubmitFilter} /> */}
        {/* <h1>nuevo h1</h1> */}
        {/* <PriceAdjustForm
          makeAdjustment={(percentage) => adjustPricesGlobally(percentage)}
          onCancel={() => setVisibleAdjust(false)}
        /> */}
      {/* </FloatingForm> */}

      <FloatingForm visible={showModalSearch} onClose={() => setShowModalSearch(false)}
      topClass="top-16"
      rightClass="right-10"
      containerClass="w-2/6">
        <AdvancedInventoryForm
          onSubmit={async (values) => {

            let param = Object.keys(values).reduce((a, b) => {
              if (values[b] && values[b] !== 'all') {
                return [...a, `${b}=${values[b]}`]
              }
              return a
            }, [] as any)

            setSearchParams(param)
            getItemsByWarehouse(param, 0)
            // if (currentPage === 0) {
            //   setLoading(true)
            //   await dispatch(
            //     fetchExistences(
            //       selectedLocation?.id,
            //       param,
            //       [`pageNumber=${1}`, `pageSize=${userConfig.rowsPerPage}`],
            //       currentEvaluate
            //     )
            //   )
            //   setShowModalSearch(false)
            //   setLoading(false)
            // } else {
            //   setCurrentPage(0)
            // }
          }}
          onCloseAdvancedForm={() => setShowModalSearch(false)}
        />
      </FloatingForm> 

      {/* <ModalInventorySearch
        //Adjustment
        onSubmitInventory={fetchExistencesToAdjust}
        modalSearch={adjustModal}
        onCloseModalSearch={() => {
          setAdjustModal(false)
          setExistencesToAdjust([])
        }}
      /> */}

      <ModalViewWithTabs
        display={modalFromRow}
        onClose={() => {
          setModalFromRow(false)
          setDataWithTabs([])
        }}
        dataWithTabs={dataWithTabs}
      />

      <Modal
        display={pdfModalAndData.modal}
        onClose={() => setPdfModalAndData({ data: [], modal: false })}
        xlClasses={'xl:w-4/5 xl:h-4/5'}
        lgClasses={'lg:w-4/5 lg:h-4/5'}
        innerStyle={{ height: '80vh' }}
      >
        <PdfView
          downloadTitle={'REPORTE_DE_INVENTARIO'}
          column_styles={{ ITEM: { width: 700 }, DESCRIPCIÓN: { width: 700 } }}
          type="INVENTORY"
          footer_render={{
            warehouse: selectedLocation?.name || 'Sin almacén',
          }}
          title={'REPORTE DE INVENTARIO'}
          columns={['ITEM', 'DESCRIPCIÓN', 'CANTIDAD']}
          data={pdfModalAndData.data}
        />
      </Modal>

      {selectedLocation && (
        <Modal
          display={adjustExistenceModal}
          xlClasses="xl:w-4/5"
          onAccept={() => null}
          scroll="scroll"
          onClose={() => {
            setAdjustExistenceModal(false)
            setExistencesToAdjust([])
          }}
        >
          <AdjustExistence
            existences={existencesToAdjust}
            onClose={() => setAdjustExistenceModal(false)}
            location={selectedLocation}
          ></AdjustExistence>
        </Modal>
      )}

      <Modal
        // modalClasses="w-3/6 py-4 px-12"
        display={showAddModal}
        onAccept={() => null}
        onClose={() => {
          setShowAddModal(false)
          setEditingLocation(null)
        }}
        xlClasses="w-[500px]"
      >
        <LocationForm
          useType={editingLocation ? 'edit' : 'create'}
          submitting={loading}
          onSubmit={onSubmit}
          defaultValues={editingLocation}
        />
      </Modal>
    </div>
  )
}

export default Existence
